import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, ogImage, canonical, schema }) => {
  const siteName = 'St. Andrews World School';
  const defaultDescription = 'St. Andrews World School, Sonipat is a premier school committed to providing quality education with state-of-the-art facilities and dedicated faculty.';
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://www.sawssonipat.com';

  const metaTitle = title ? `${title} | ${siteName}` : `${siteName} | School of Excellence`;
  const metaDesc = description || defaultDescription;
  const metaImage = ogImage || `${siteUrl}/og-image.jpg`;
  const schemaArray = Array.isArray(schema) ? schema : (schema ? [schema] : []);

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDesc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical || siteUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={metaImage} />
      {schemaArray.map((obj, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
